import * as React from 'react';
//import React from "react";
import {  ContentState, EditorState, RawDraftContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
export interface IProps{
  datevalue;
  OnChange;
}

export default class MIPARichTextEdit extends React.Component<IProps,{}>{
    public state={editorState:EditorState.createEmpty()};
  constructor(props: IProps) {
    
    super(props);  
    const html = props.datevalue;
    const contentBlock = htmlToDraft(html);
    if (contentBlock!=null) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
        /*background: "",
        isOpen: false,
        emailBody: `<p id="para">test</p>`,
        fontcolor: ""*/
      };
    }
  }
  public render() {
    /*let _contentState = ContentState.createFromText(this.props.datevalue);
    const raw = convertToRaw(_contentState)
    const { editorState } = this.state;*/
    return (        
     
      <Editor
      editorState={this.state.editorState}
      wrapperClassName="demo-wrapper"
      editorClassName="demo-editor"
      onEditorStateChange={this.onEditorStateChange}
      onChange={(contentState: RawDraftContentState)=>{
        this.props.OnChange(draftToHtml(contentState));
      }}
  toolbar={{
    inline: { inDropdown: true ,
      options:[
        "bold",
      "italic",
      "underline",
      ]
    },
    blockType:{className:'hidentools'},
    list:{inDropdown: true},
    link:{className:'hidentools'},
    history:{className:'hidentools'},
    fontFamily:{className:'hidentools'},
    emoji:{className:'hidentools'},
    image:{className:'hidentools'},
    remove:{className:'hidentools'}
    
    //list: { inDropdown: true,options:[] },
    //textAlign: { inDropdown: true },
    //link: { inDropdown: true },
    //history: { inDropdown: true }
  }}
/>
    );
  }

  onEditorStateChange = editorState => {
      
    this.setState({
      editorState
    });
  };


  onEditorChange = evt => {
    this.setState({
      emailBody: evt.editor.getData()
    });
  };

  /*componentDidMount() {
    document.getElementById("para").style.color = "red !important";
  }

  handleChangeComplete = color => {
    this.setState({ background: color.hex });
    document.getElementById(
      "test"
    ).style.backgroundColor = this.state.background;
  };*/
  /*handleChange = value => {
    this.setState(
      {
        fontcolor: value.toString()
      },
      () => {
        return (document.getElementById(
          "para"
        ).style.color = this.state.fontcolor);
      }
    );
  };*/
  /*handleChangeAlignment = data => {
    this.setState(
      {
        alignment: data.toString()
      },
      () => {
        return (document.getElementById(
          "para"
        ).style.textAlign = this.state.alignment);
      }
    );
  };*/
  /*handlebackground = data => {
    this.setState(
      {
        backgroundcolor: data.toString()
      },
      () => {
        return (document.getElementById(
          "para"
        ).style.backgroundColor = this.state.backgroundcolor);
      }
    );
  };*/
  

}


